import React from "react";

import ReachRim from "../ReachRim/ReachRim";
import "./NextStepCtaDark.css";

export default function NextStepCtaDark() {
  return (
    <section className="next-step-cta-dark">
      <div className="w-layout-blockcontainer intensive-container w-container">
        <ReachRim variant="cta" className="next-step-cta-dark__banner">
          <div className="next-step-cta-dark__copy">
            <h2 className="next-step-cta-dark__heading">
              Ready to Take the Next Step?
            </h2>
            <p className="next-step-cta-dark__subtext">
              Speak with our Career Expert and get personalized guidance before
              you join.
            </p>
          </div>
          <a href="#form-container" className="next-step-cta-dark__btn track-button">
            Request a Call Back
          </a>
        </ReachRim>
      </div>
    </section>
  );
}
